<template>
    <!-- 上传文件 -->
    <el-dialog class="dialog" v-if="dialogMoveFiles" :visible.sync="dialogMoveFiles" :close-on-click-modal="false" top="15vh" >

        <el-form  :model="filesForm" :rules="rulesFiles" ref="filesForm" label-width="100px" v-if="dialogMoveFiles">
            <el-form-item label="移动到" prop="folderPid">
                <el-cascader size="small"  v-model="filesForm.folderPid" :options="folderOptions" :props="propsFolder"  filterable clearable placeholder="请选择文件夹" style="min-width:300px; width:50%"></el-cascader>
            </el-form-item>

        </el-form>

        <div class="dialog-butn-box" style="margin: 30px 0 0">
            <el-button size="small" @click="dialogMoveFiles = false">取 消</el-button>
            <el-button size="small" type="primary" @click="handleSave">确 定</el-button>
        </div>

    </el-dialog>
</template>

<script>
import {folderTreeByPid_ajax, choiceLabel_ajax,saveUploadFile_ajax} from '@File~/api/file'

export default {
    data() {
        return {
            dialogMoveFiles: false,

            filesForm:{
                folderPid:[]
            },
            rulesFiles:{
                folderPid:[{ required: true, message: '请选择已有文件夹', trigger: ['change','blur'] }],
            },

            folderOptions:[],
            propsFolder:{
                checkStrictly: true,
                expandTrigger: 'hover',
                value:'id',
                label:'folderName',
                children:'childList'
            },


        }
    },

    methods: {
        init() {
            
            this.getFolders();
        },

        // 获取已有文件夹列表
        getFolders() {
            this.folderOptions = []
            const folderPid = this.$store.getters.currentRoute.meta.id
            folderTreeByPid_ajax(folderPid).then(response => {
                if(response.code == 1) {
                    this.folderOptions = response.data
                    this.filesForm.folderPid = []
                    this.dialogMoveFiles = true
                }
            })
        },

     
        
        // 确定
        handleSave() {
            this.$refs['filesForm'].validate((valid) => {
                if (valid) {
                    this.dialogMoveFiles = false;
                    this.$emit('handleMove',this.filesForm.folderPid)
                }
            })
        },

    }
}
</script>

<style lang="scss" scoped>
    .dialog{
        ::v-deep .el-dialog{
            min-width: 600px;
            width: 40vw;
        }
       ::v-deep .el-dialog__body{
           padding: 10px 20px 30px;
       } 
       .filter-item{
           margin-bottom: 20px;
       }
       .el-form{
           margin-top:20px;
           height: calc(100vh - 80vh);
           overflow-x: hidden;
           overflow-y:auto;
       }
    }
</style>